import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";

const featuredProducts = [
  {
    id: 1,
    name: "Elegance Pro",
    category: "Rasmiy",
    price: 2499000,
    image: require("../assets/images/skechers/11.jpg"),
    description: "Italiya terisi bilan tayyorlangan minimalistik dizayn",
  },
  {
    id: 2,
    name: "Urban Stride",
    category: "Kundalik",
    price: 1899000,
    image: require("../assets/images/skechers/2oq.jpg"),
    description: "Zamonaviy hayot tarzi uchun yuqori qulaylik",
  },
  {
    id: 3,
    name: "Apex Runner",
    category: "Sport",
    price: 2199000,
    image: require("../assets/images/skechers/3pair.jpg"),
    description: "Yuqori samaradorlik va bardoshli materiallar",
  },
  {
    id: 4,
    name: "Classic Loafer",
    category: "Rasmiy",
    price: 2299000,
    image: require("../assets/images/skechers/4yashil.jpg"),
    description: "Klassik dizayn zamonaviy qulaylik texnologiyasi bilan",
  },
];

const FeaturedProducts = () => {
  return (
    <section className="featured-products sp-t" id="generalFeatures">
      <Container>
        <Row>
          <Col lg={8} className="mx-auto text-center mb-5">
            {/* - Section Heading - */}
            <div className="section-heading">
              <div className="sub-heading">
                <p>Bizning Kolleksiyamiz</p>
              </div>
              <div className="heading-title">
                <h2>Mashhur Mahsulotlar</h2>
              </div>
              <div className="heading-description">
                <p>
                  Eng ko'p so'raladigan, dunyoning eng yaxshi brendlaridan
                  keltirilgan poyabzallarni kashf eting
                </p>
              </div>
            </div>
            {/* - Section Heading - */}
          </Col>
        </Row>

        <Row>
          {featuredProducts.map((product) => (
            <Col key={product.id} lg={3} md={6} className="mb-4">
              <div className="product-card">
                <div className="product-image">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="img-fluid"
                  />
                  <div className="product-overlay">
                    <Link to="#" className="btn btn-sm btn-primary">
                      View Details
                    </Link>
                  </div>
                </div>
                <div className="product-info">
                  <div className="product-category">{product.category}</div>
                  <h3 className="product-name">{product.name}</h3>
                  <p className="product-description">{product.description}</p>
                </div>
              </div>
            </Col>
          ))}
        </Row>

        <Row className="mt-5">
          <Col className="text-center">
            <Link
              to="https://t.me/+EJTyMYqdrLY5MWVi"
              className="btn btn-lg btn-outline-primary"
            >
              Barcha Kolleksiyani Ko'rish
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default FeaturedProducts;
